import React, { Component, PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import shallowCompare from 'react-addons-shallow-compare';
import SiteSelectorItem from './SiteSelectorItem';
import { displayCreationModal } from 'saas/sites/modals';
import Modal from 'common/components/Modal';
import cx from 'classnames';

class SiteSelector extends Component {
  constructor(props) {
    super(props);

    this.state = {};
    this._onAddSite = this._onAddSite.bind(this);
  }

  _onAddSite(evt) {
    evt.stopPropagation();
    evt.preventDefault();

    const onSaved = this.props.onAdded;

    // Displaying site modal
    displayCreationModal(this.props.customer, onSaved);
  }

  shouldComponentUpdate(nextProps) {
    return shallowCompare(this, nextProps);
  }

  render() {
    const { sites, selected, onSelected, onUnselected, errors } = this.props;

    const isSiteSelected = s =>
      selected.some(cs => cs.id.toString() === s.id.toString());

    const filteredSites = sites.filter(
      s => s.deleted !== true || isSiteSelected(s)
    );

    const hasError = (global = false) => {
      if (errors) {
        return errors.has('site.empty');
      }
      return false;
    };

    const onSiteUnselect = id => {
      this.setState({
        warningModalOpened: true,
        warningModalSite: id,
      });
    };

    const onSiteChange = (id, value) => {
      if (!value) {
        onSelected(id);
      } else {
        onSiteUnselect(id);
      }
    };

    const onModalConfirm = () => {
      const { warningModalSite } = this.state;
      this.setState({
        warningModalOpened: false,
        warningModalSite: undefined,
      });
      onUnselected(warningModalSite);
    };

    const onModalClose = id => {
      this.setState({
        warningModalOpened: false,
        warningModalSite: undefined,
      });
    };

    const selectorLabel = this.props.monoSite
      ? 'Site concerné par la demande'
      : 'Sites concernés par la demande';

    const segmentClasses = cx('ui segment form', {
      error: hasError(),
    });

    const { warningModalOpened } = this.state;

    return (
      <div className={segmentClasses}>
        <h3 className="ui header">
          {selectorLabel}
          <button
            className="ui right floated labeled icon button"
            onClick={this._onAddSite}
          >
            <i className="icon add" />
            Ajouter un site
          </button>
        </h3>
        {hasError(true) && (
          <div className="ui error message">
            <p>Vous devez sélectionner au moins un site.</p>
          </div>
        )}
        <br />
        <div className="ui inline fields grid checkBoxList">
          {filteredSites.map(s => (
            <SiteSelectorItem
              key={s.id}
              site={s}
              value={isSiteSelected(s)}
              onChange={onSiteChange}
              error={hasError()}
            />
          ))}
        </div>
        <Modal
          isOpened={!!warningModalOpened}
          closable
          onConfirm={onModalConfirm}
          onClose={onModalClose}
        >
          <div className="header">Confirmation de suppression</div>
          <div className="content">
            <div>
              Êtes-vous sûr(e) de vouloir décocher ce site ? <br />
              Toutes les informations du diagnostic pour ce site seront perdues.
              L'étude et les interventions non exécutées seront annulées.
            </div>
          </div>
          <div className="actions">
            <div className="actions">
              <button className="ui button" onClick={onModalClose}>
                Annuler
              </button>
              <button className="ui red button" onClick={onModalConfirm}>
                Confirmer
              </button>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

SiteSelector.propTypes = {
  customer: PropTypes.string.isRequired,
  sites: PropTypes.array.isRequired,
  selected: PropTypes.array.isRequired,
  onAdded: PropTypes.func.isRequired,
  onSelected: PropTypes.func.isRequired,
  onUnselected: PropTypes.func.isRequired,
  monoSite: PropTypes.bool,
  errors: ImmutablePropTypes.map,
};

export default SiteSelector;



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases/form/components/SiteSelector.js